/*=============================================================================
 * Copyright (C) 2017 Stephen F. Norledge and Alces Flight Ltd.
 *
 * This file is part of Flight Reactware.
 *
 * All rights reserved, see LICENSE.txt.
 *===========================================================================*/
export var NAME = 'loadingState';
export var PENDING = 'PENDING';
export var RESOLVED = 'RESOLVED';
export var REJECTED = 'REJECTED';